import React from 'react';

import Checkbox from '@mui/material/Checkbox';

const CheckboxBase = (props) => <Checkbox {...props} />;

export default CheckboxBase;
